import { useTranslation } from 'react-i18next';

const useLocalizer = (key: string, nameSpace?: string): string => {
    const { t } = useTranslation(nameSpace);

    return (t(key?.toLowerCase()));
}
export default useLocalizer;